import { createSlice } from "@reduxjs/toolkit";
import { GullLayoutSettings } from "../../GullLayout/settings";

const initialState = {
  settings: {
    ...GullLayoutSettings,
  },
  defaultSettings: {
    ...GullLayoutSettings,
  },
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setLayoutSettings: (state, action) => {
      state.settings = action.payload;
    },
    setDefaultSettings: (state, action) => {
      state.defaultSettings = action.payload;
    },
    setNavigation: (state, action) => {
      state.navigations = action.payload.navigations;
    },
  },
});

export const { setLayoutSettings, setDefaultSettings, setNavigation } = layoutSlice.actions;
export default layoutSlice.reducer;
